import { Component, OnInit } from '@angular/core';
import { WiseIdAuthServiceManager } from '../../features/sso-wise-id/controller/wise-id-auth.service-manager';
import { UserResult } from '@rfebm/sso-api';
import { CommonModule } from '@angular/common';

interface UserDictionary {
  label: string;
  value: string;
}

@Component({
  selector: 'app-profile',
  templateUrl: 'profile.component.html',
  styleUrls: ['profile.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ProfileComponent implements OnInit {

  user: UserResult | null = null;

  displayName: string = 'Invitado';
  profileFields: UserDictionary[] = [];

  constructor(
    private readonly wiseIdAuthServiceManager: WiseIdAuthServiceManager
  ) { }

  ngOnInit() {
    this.user = this.wiseIdAuthServiceManager.getUserSessionData();
    this.displayName = this.user?.name || this.user?.loginName || this.user?.email || 'Invitado';

    for (const key in this.user) {
      if (this.user.hasOwnProperty(key)) {
        this.profileFields.push({
          label: key,
          value: JSON.stringify(this.user[key]) || ''
        });
      }
    }


  }

}
